const dictionaries = {
  deu: () => import("@/dictionaries/deu.json").then((module) => module.default),
  eng: () => import("@/dictionaries/eng.json").then((module) => module.default),
  esl: () => import("@/dictionaries/esl.json").then((module) => module.default),
  fra: () => import("@/dictionaries/fra.json").then((module) => module.default),
  heb: () => import("@/dictionaries/heb.json").then((module) => module.default),
  ita: () => import("@/dictionaries/ita.json").then((module) => module.default),
  por: () => import("@/dictionaries/por.json").then((module) => module.default),
};

type Locale = keyof typeof dictionaries;

export const getDictionary = async (locale: Locale = "eng") => {
  const loadDictionary = dictionaries[locale];

  if (!loadDictionary) {
    throw new Error(`Dictionary for locale '${locale}' not found.`);
  }

  try {
    return await loadDictionary();
  } catch (error) {
    throw new Error(`Failed to load dictionary for locale '${locale}': ${error}`);
  }
};
